export default __webpack_public_path__ + "static/media/r6s_logo_ru.b5c68f05.png";